import BgImage from './BgImage';
export default BgImage;
